const setProjectStatus = (payload) => {
  return {
    type: "setProjectStatus",
    payload,
  };
};

export default setProjectStatus;
